export enum RoomStatus {
  Open = "open",
  Completed = "completed",
  Trapped = "trapped"
}

export interface RoomState {
  active: boolean;
  order: number;
  status: RoomStatus;
}

export type RoomStates = Record<string, RoomState>;

export interface ProfileSettings {
  profileName: string;
  escapeRoomTime: number;
  rooms: RoomStates;
  schoolInput: boolean;
  singleRoom: boolean;
  showDifficultyIndicators: boolean;
  branding?: "gemba" | "actica" | "ntegra";
}

export type DifficultyLevel = 1 | 2 | 3 | 4;

// Global admin overrides of room difficulty (room id -> level), shared by every
// event. Rooms without an entry use their built-in default from Config/config.ts.
export type DifficultyRatings = Partial<Record<string, DifficultyLevel>>;

export type RoomDetails = {
  id: string;
  state: boolean;
  order: number;
  status: RoomStatus;
  className: string;
  label: string;
  difficulty: DifficultyLevel;
}

export interface Event {
  id: string;
}


